module.exports = __webpack_public_path__ + "img/toko2.6d8e4d88.jpg";